import { isAfter } from "date-fns";
import { HeadCell } from "../../components/Table/helpers";
import {
  isProgrammeHasListeProduit,
  isProgrammeHasRenouvellement,
} from "../../helpers/programme";
import {
  AdhesionAdherentParticulierResponse,
  Programme,
} from "../../services/Api/swagger";
import { TabItem } from "./hooks/programme";

export const buildTabs = (
  programme: Programme,
  selectedAdhesion: AdhesionAdherentParticulierResponse
): TabItem[] => {
  const hasFid = selectedAdhesion.hasFidelisation;
  const listProduitExist = isProgrammeHasListeProduit(programme);
  const hasRenouvellement = isProgrammeHasRenouvellement(programme);
  const hasResiliation = selectedAdhesion.dateEcheance && isAfter(new Date(selectedAdhesion.dateEcheance), new Date())
  let tabs = [
    {
      title: "Mes informations",
      value: "informations",
      index: 0,
    },
  ];

  if (listProduitExist) {
    tabs.push({
      title: "Mes avantages",
      value: "avantage",
      index: tabs.length,
    });
  }

  if (hasRenouvellement) {
    tabs.push({
      title: "Renouvellement",
      value: "renouvellement",
      index: tabs.length,
    });
  }

  if (hasResiliation) {
    tabs.push({
      title: "Résiliation",
      value: "resiliation",
      index: tabs.length,
    });
  }

  // not added for [Production]
  if (hasFid && !window.location.hostname.startsWith('part')) {
    tabs.push({
      title: "Programme de fidélité",
      value: "fidelite",
      index: tabs.length,
    });
  }

  return tabs;
};
export interface TableDataTransaction {
  /**
   * date de la transaction
   * @type {string}
   * @memberof Transaction
   */
  date: string;
  /**
   * type de l\'achat
   * @type {string}
   * @memberof Transaction
   */
  detail: string;
  /**
   * montant de l\'achat en euros
   * @type {string}
   * @memberof Transaction
   */
  montant: string;
  /**
   *
   * @type {number}
   * @memberof Transaction
   */
  credit?: string;
  /**
   *
   * @type {string}
   * @memberof Transaction
   */
  debit?: string;
}
export const headCells = (): HeadCell[] => {
  return [
    {
      id: "date",
      numeric: false,
      disablePadding: true,
      label: "Date",
    },
    {
      id: "detail",
      numeric: false,
      disablePadding: true,
      label: "Détail",
    },
    {
      id: "montant",
      numeric: false,
      disablePadding: true,
      label: "Montant",
    },
    {
      id: "credit",
      numeric: true,
      disablePadding: true,
      label: "Crédit",
    },
    {
      id: "debit",
      numeric: true,
      disablePadding: true,
      label: "Débit",
    },
  ];
};
